<template>
  <div class="home-page">

    <!-- Banner轮播 Section - 满屏显示 (减去顶部栏和导航栏高度) -->
    <v-carousel
        cycle
        hide-delimiters
        height="calc(39.58vw)"
        :show-arrows="!isMobile"
        class="banner-carousel"
    >
      <v-carousel-item>
        <div class="banner-container">
          <v-img
              src="/images/hero1.jpg"
              class="banner-image"
              cover
          ></v-img>
          <div class="banner-overlay"></div>
          <v-container class="banner-content-container">
            <v-row align="center" justify="center" class="banner-content">
              <v-col cols="12" md="10">
                <BannerContent/>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-carousel-item>  <v-carousel-item>
        <div class="banner-container">
          <v-img
              src="/images/hero2.jpg"
              class="banner-image"
              cover
          ></v-img>
          <div class="banner-overlay"></div>
          <v-container class="banner-content-container">
            <v-row align="center" justify="center" class="banner-content">
              <v-col cols="12" md="10">
                <BannerContent/>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-carousel-item>

      <v-carousel-item>
        <div class="banner-container">
          <div class="video-wrapper">
          <video
              class="banner-video"
              autoplay
              loop
              muted
              playsinline
              cover
          >
            <source src="/videos/banner.mp4" type="video/mp4">
          </video>
          </div>
          <div class="banner-overlay"></div>
          <v-container class="banner-content-container">
            <v-row align="center" justify="center" class="banner-content">
              <v-col cols="12" md="10">
                <BannerContent></BannerContent>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-carousel-item>
    </v-carousel>


    <!-- 公司介绍（抽离组件） -->
    <CompanyIntro>
      <template #stats>
        <!-- 公司统计数据 -->
        <v-row justify="center" class="mt-12">
          <v-col cols="12">
            <div class="company-stats-section" ref="statsSection">
              <v-container>
                  <v-row>
                  <v-col cols="12" sm="6" md="3" class="text-center stat-col">
                    <div class="stat-card app-card" :class="{ 'animate-in': isVisible }" :style="{ '--delay': '0s' }">
                      <div class="stat-icon-wrapper">
                        <v-icon size="40" class="stat-icon">mdi-bank</v-icon>
                      </div>
                      <div class="stat-number" ref="stat1">{{ animatedStats.capital }}</div>
                      <div class="stat-label">{{ $t('home.stats.registeredCapital') }}</div>
                      </div>
                    </v-col>
                  <v-col cols="12" sm="6" md="3" class="text-center stat-col">
                    <div class="stat-card app-card" :class="{ 'animate-in': isVisible }" :style="{ '--delay': '0.1s' }">
                      <div class="stat-icon-wrapper">
                        <v-icon size="40" class="stat-icon">mdi-chart-line</v-icon>
                      </div>
                      <div class="stat-number" ref="stat2">{{ animatedStats.years }}+</div>
                      <div class="stat-label">{{ $t('home.stats.yearsExperience') }}</div>
                      </div>
                    </v-col>
                  <v-col cols="12" sm="6" md="3" class="text-center stat-col">
                    <div class="stat-card app-card" :class="{ 'animate-in': isVisible }" :style="{ '--delay': '0.2s' }">
                      <div class="stat-icon-wrapper">
                        <v-icon size="40" class="stat-icon">mdi-factory</v-icon>
                      </div>
                      <div class="stat-number" ref="stat3">{{ animatedStats.factoryArea }}m²</div>
                      <div class="stat-label">{{ $t('home.stats.factoryArea') }}</div>
                      </div>
                    </v-col>
                  <v-col cols="12" sm="6" md="3" class="text-center stat-col">
                    <div class="stat-card app-card" :class="{ 'animate-in': isVisible }" :style="{ '--delay': '0.3s' }">
                      <div class="stat-icon-wrapper">
                        <v-icon size="40" class="stat-icon">mdi-earth</v-icon>
                      </div>
                      <div class="stat-number" ref="stat4">{{ animatedStats.countries }}+</div>
                      <div class="stat-label">{{ $t('home.stats.crossBorderMarkets') }}</div>
                      </div>
                    </v-col>
                  </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
      </template>
    </CompanyIntro>

    <!-- 客户案例 -->
    <section class="customer-cases py-12">
      <v-container class="content-container">
        <v-row>
          <v-col cols="12" class="text-center mb-8">
            <h2 class="text-h3 font-weight-bold mb-4">{{ $t('home.customerCases.title') }}</h2>
            <p class="text-h6 text-medium-emphasis">{{ $t('home.customerCases.subtitle') }}</p>
          </v-col>
        </v-row>
        <v-row class="customer-cases-row" justify="center">
          <v-col cols="12">
            <!-- 桌面端：使用 v-slide-group -->
            <div class="cases-carousel-container d-none d-md-block">
              <v-slide-group 
                ref="slideGroupRef" 
                class="cases-slide-group"
                v-model="casesActiveId"
                center-active
                show-arrows="always"
              >
                <v-slide-group-item 
                  v-for="caseItem in currentLocaleCases" 
                  :key="caseItem.id"
                  class="case-slide-item"
                  :value="caseItem.id"
                >
                  <v-card class="case-card case-card--carousel" elevation="0" >
                    <div class="case-layout">
                      <div class="case-content-section">
                        <div class="case-header-info">
                          <h3 class="case-customer-name">{{ caseItem.customerName }}</h3>
                </div>
                        <div class="case-product-info">{{ caseItem.products }}</div>
                        <div class="case-highlights">{{ caseItem.highlights }}</div>
                        <div class="case-testimonial">
                          <span class="testimonial-text">"{{ caseItem.testimonial }}"</span>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-slide-group-item>

                <template #prev="{ prev }">
                  <v-btn
                    class="cases-nav-btn cases-nav-btn--left"
                    @click.stop="prev()"
                    icon
                    size="large"
                    color="primary"
                    variant="elevated"
                  >
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </template>

                <template #next="{ next }">
                  <v-btn
                    class="cases-nav-btn cases-nav-btn--right"
                    @click.stop="next()"
                    icon
                    size="large"
                    color="primary"
                    variant="elevated"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </template>
              </v-slide-group>
            </div>

            <!-- 移动端：使用 v-carousel 满屏轮播 -->
            <div class="cases-mobile-carousel d-md-none" :style="{ minHeight: mobileCarouselMinHeight }">
              <v-carousel
                v-model="mobileCarouselIndex"
                height="auto"
                :show-arrows="false"
                hide-delimiters="false"
                hide-delimiter-background
                class="cases-carousel"
                cycle
                interval="5000"
                @update:model-value="calculateMobileCarouselHeight"
              >
                <v-carousel-item
                  v-for="caseItem in currentLocaleCases"
                  :key="caseItem.id"
                >
                  <div class="carousel-item-wrapper">
                    <v-card class="case-card case-card--mobile" elevation="2">
                      <div class="case-layout">
                        <div class="case-content-section">
                          <div class="case-header-info">
                            <h3 class="case-customer-name">{{ caseItem.customerName }}</h3>
                          </div>
                          <div class="case-product-info">{{ caseItem.products }}</div>
                          <div class="case-highlights">{{ caseItem.highlights }}</div>
                          <div class="case-testimonial">
                            <span class="testimonial-text">"{{ caseItem.testimonial }}"</span>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </div>
                </v-carousel-item>
              </v-carousel>
                    </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 技术与研发 Section -->
    <section class="tech-section py-16">
      <v-container class="content-container">
        <v-row justify="center" class="mb-12">
          <v-col cols="12" class="text-center">
            <h2 class="text-h3 font-weight-bold">{{ $t('home.techTitle') }}</h2>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col v-for="(feature, key) in ['team', 'components', 'solutions', 'standards']" :key="key" cols="12" sm="6"
                 lg="3" class="d-flex">
            <v-card class="tech-card app-card fill-height" flat elevation="0">
              <v-card-text class="text-center pa-6">
                <div class="tech-icon-wrapper">
                  <v-icon class="tech-icon">
                    {{ getTechIcon(feature) }}
                  </v-icon>
                </div>
                <h3 class="text-h5 font-weight-bold mb-2">{{ $t(`home.techFeatures.${feature}.title`) }}</h3>
                <p class="text-body-1">{{ $t(`home.techFeatures.${feature}.desc`) }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 视频展示 Section -->
    <section class="video-section py-16 grey lighten-4">
      <v-container class="content-container">
        <v-row justify="center" class="mb-12">
          <v-col cols="12" class="text-center">
            <h2 class="text-h3 font-weight-bold mb-2">{{ $t('home.videoGallery') }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <div class="video-card app-card">
              <div class="video-container">
                <video
                    src="/videos/2.mp4"
                    class="video-preview"
                    muted
                    loop
                    @click="playVideo"
                ></video>
                <div class="video-overlay d-flex align-center justify-center">
                  <v-btn icon="mdi-play" size="x-large" color="white" @click="playVideo"></v-btn>
                </div>
              </div>
              <v-card-text class="text-center">
                <h3 class="text-h6">{{ $t('home.factoryTour') }}</h3>
              </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <div class="video-card app-card">
              <div class="video-container">
                <video
                    src="/videos/3.mp4"
                    class="video-preview"
                    muted
                    loop
                    @click="playVideo"
                ></video>
                <div class="video-overlay d-flex align-center justify-center">
                  <v-btn icon="mdi-play" size="x-large" color="white" @click="playVideo"></v-btn>
                </div>
              </div>
              <v-card-text class="text-center">
                <h3 class="text-h6">{{ $t('home.productDemo') }}</h3>
              </v-card-text>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <div class="video-card app-card">
              <div class="video-container">
                <video
                    src="/videos/4.mp4"
                    class="video-preview"
                    muted
                    loop
                    @click="playVideo"
                ></video>
                <div class="video-overlay d-flex align-center justify-center">
                  <v-btn icon="mdi-play" size="x-large" color="white" @click="playVideo"></v-btn>
                </div>
              </div>
              <v-card-text class="text-center">
                <h3 class="text-h6">{{ $t('home.exhibitionHighlights') }}</h3>
              </v-card-text>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 推荐产品 Section -->
    <section class="featured-products py-16">
      <v-container class="content-container">
        <v-row justify="space-between" align="center" class="mb-12">
          <v-col cols="12" md="6">
            <h2 class="text-h3 font-weight-bold">{{ $t('home.featuredProducts') }}</h2>
          </v-col>
          <v-col cols="12" md="6" class="text-md-right">
            <v-btn
                color="primary"
                variant="outlined"
                :to="{ path: '/products' }"
                class="text-none"
            >
              {{ $t('home.viewAllProducts') }}
              <v-icon end>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="product in featuredProducts" :key="product.id" cols="12" sm="6" md="3">
            <v-card class="product-card app-card">
              <v-img :src="product.image" height="250" cover>
              </v-img>
              <v-card-text>
                <h3 class="text-h6 mb-2">{{ getLocalizedText(product.name) }}</h3>
                <p class="text-truncate">{{ getLocalizedText(product.description) }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                    block
                    color="primary"
                    variant="outlined"
                    :to="{ path: `/products/${product.id}` }"
                    class="text-none"
                >
                  {{ $t('home.exploreProducts') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>


  </div>
</template>

<script setup lang="ts">
import {ref, computed, onMounted, onUnmounted, onBeforeMount, nextTick, watch} from 'vue';
import {useScroll, useWindowSize} from '@vueuse/core';
import {useI18n} from 'vue-i18n';
import {productCategories} from '@/data/products';
import ContactSection from '@/components/ContactSection.vue';
import BannerContent from '@/components/BannerContent.vue';
import CompanyIntro from '@/components/CompanyIntro.vue';

// 统计数据动画相关
const statsSection = ref(null)
const isVisible = ref(false)
const animatedStats = ref({
  capital: '0万',
  years: 0,
  factoryArea: '0',
  countries: 0
})

// 数字动画函数
const animateNumber = (start: number, end: number, duration: number, callback: (val: string) => void, suffix: string = '') => {
  const startTime = Date.now()
  const animate = () => {
    const elapsed = Date.now() - startTime
    const progress = Math.min(elapsed / duration, 1)

    // 使用缓动函数
    const easeOutQuart = 1 - Math.pow(1 - progress, 4)
    const current = Math.floor(start + (end - start) * easeOutQuart)

    callback(current + suffix)

    if (progress < 1) {
      requestAnimationFrame(animate)
    }
  }
  animate()
}

// 启动统计数据动画
const startStatsAnimation = () => {
  if (isVisible.value) return // 防止重复触发

  isVisible.value = true

  // 延迟启动数字动画，让卡片先入场
  setTimeout(() => {
    // 注册资本动画 (1000万)
    animateNumber(0, 1000, 2000, (val) => {
      animatedStats.value.capital = val + '万'
    })

    // 年限动画
    setTimeout(() => {
      animateNumber(0, 10, 1500, (val) => {
        animatedStats.value.years = parseInt(val)
      })
    }, 200)

    // 工厂面积动画  
    setTimeout(() => {
      animateNumber(0, 33000, 1800, (val) => {
        animatedStats.value.factoryArea = parseInt(val).toLocaleString()
      })
    }, 400)

    // 国家数量动画
    setTimeout(() => {
      animateNumber(0, 50, 2200, (val) => {
        animatedStats.value.countries = parseInt(val)
      })
    }, 600)
  }, 400)
}

// Intersection Observer
let observer: IntersectionObserver | null = null


// 客户案例数据
const mockCases = [
  {
    id: 1,
    customerName: 'North Kazakhstan Oblast Wheat Farming Consortium',
    location: 'Kazakhstan',
    flag: '/images/flags/kz.svg',
    products: '25 units of 160-horsepower (HP) wheeled tractors',
    highlights: 'In May 2025, 160-HP wheeled tractors were customized for the Kazakh customer, equipped with universal hitching devices for subsoilers and seeders. The transmission gear ratio was optimized (increasing operating speed by 20%), and implement switching takes only 15 minutes per unit, making the tractors suitable for wheat crop rotation. The entire delivery process was completed in 50 days. Customer feedback shows a 40% improvement in operating efficiency.',
    testimonial: 'It can start with one click even at -30℃ and saves water too! The sowing speed is so much faster—this is equipment that really understands our needs!',
    author: 'Consortium Representative'
  },
  {
    id: 2,
    customerName: 'Chao Phraya Delta Rice Farming Cooperative',
    location: 'Thailand',
    flag: '/images/flags/th.svg',
    products: '30 units of crawler-type paddy tractors + 20 units of rice combine harvesters with straw crushing and soil incorporation function',
    highlights: 'In June 2025, to address the demands of Thailand\'s rainy-season paddy field operations, the tractors are equipped with widened crawler tracks (45cm in width) and anti-bogging wheel design, significantly reducing the risk of getting stuck in muddy paddy fields. The equipment is optimized for Thailand\'s hot and humid climate, and the harvesters are fitted with straw crushing mechanisms that process straw into fragments of ≤10cm for on-site soil incorporation. The entire delivery process was completed in 35 days. Per customer feedback, the harvesting cycle for 800 hectares of rice was shortened from 25 days to 18 days.',
    testimonial: 'The crawler tractors never get bogged down during the rainy season, and the harvesters eliminate the hassle of straw disposal by incorporating it directly into the soil! This is truly reliable equipment!',
    author: 'Somchai, Director of the Cooperative'
  },
  {
    id: 3,
    customerName: 'Paraná Soybean Farming Cooperative',
    location: 'Brazil',
    flag: '/images/flags/br.svg',
    products: '28 units of 140-horsepower (HP) wheeled tractors (equipped with universal hitching devices for soybean seeders and corn intertillage machines)',
    highlights: 'In August 2025, to address Brazil\'s hot and humid climate, soybean-corn crop rotation needs, and large-scale contiguous farm operations, the tractors were customized with anti-corrosion coatings and wear-resistant tires; switching between seeding and intertillage attachments takes only 20 minutes per unit. Delivery was completed in 42 days via sea freight from Shanghai Port to Santos Port, arriving in time for the sowing season. Two engineers were dispatched for on-site commissioning. Per customer feedback: Operating efficiency increased by 42%, and crop rotation attachment switching efficiency improved by 50%.',
    testimonial: 'The tractors deliver excellent anti-corrosion performance and anti-slip capability, while crop rotation attachment switching is significantly efficient! They ensured no disruption to the sowing schedule—this equipment has been incredibly trouble-free in operation.',
    author: 'Marcos, Technical Director of the Cooperative'
  },
  {
    id: 4,
    customerName: 'German Machinery Trading Company',
    location: 'Germany',
    flag: '/images/flags/de.svg',
    products: 'Acting as the authorized agent for precision testing equipment',
    highlights: 'In January 2025, we entered into an agency cooperation agreement with the German customer. We provided precision component testing instruments, assisted in completing CE certification and customs clearance procedures, and built a stable supply system with a monthly supply volume of 50 units. The customer satisfaction rate reached 98%.',
    testimonial: 'The products deliver exceptional precision, and the cross-border services are highly professional.',
    author: 'Trading Company Representative'
  }
];

const mockCasesZh = [
  {
    id: 1,
    customerName: '哈萨克斯坦北哈州小麦种植联合体',
    location: '哈萨克斯坦',
    flag: '/images/flags/kz.svg',
    products: '25 台 160 马力轮式拖拉机',
    highlights: '2025年5月，为哈萨克斯坦客户定制160拉力轮式拖拉机（配套深松犁、播种机通用挂接装置），优化变速箱速比（作业时速提升 20%），农具切换仅需 15 分钟 / 台，适配麦类轮作。50天完成全流程交付。客户反馈作业效率提升40%。',
    testimonial: '-30℃能一键启动还省水，播种速度快太多！是懂我们需求的设备！',
    author: '联合体代表'
  },
  {
    id: 2,
    customerName: '泰国湄南河三角洲水稻种植合作社',
    location: '泰国',
    flag: '/images/flags/th.svg',
    products: '30台履带式水田拖拉机+ 20 台带秸秆粉碎还田功能的水稻联合收割机',
    highlights: '2025年6月，针对泰国雨季水田模式定制方案，拖拉机采用加宽履带（宽度 45cm）与防陷轮设计，降低水田作业陷车概率；适配泰国年均 30℃以上的湿热环境，10cm内内秸秆粉碎装置。35 天全流程交付。客户反馈1.2 万亩水稻收割周期从 25 天缩至 18 天。',
    testimonial: '履带拖拉机雨季不陷车，收割机秸秆还田省麻烦！很靠谱！',
    author: '合作社社长 颂猜（Somchai）'
  },
  {
    id: 3,
    customerName: '巴西巴拉那州大豆种植合作社',
    location: '巴西',
    flag: '/images/flags/br.svg',
    products: '28 台 140 马力轮式拖拉机（配大豆播种机、玉米中耕机通用挂接装置）',
    highlights: '2025 年 8 月，针对巴西湿热气候、大豆 - 玉米轮作及连片农场需求定制方案：拖拉机涂抗腐蚀涂层、配耐磨轮胎，切换播种 / 中耕装置仅需 20 分钟 / 台；上海港 - 桑托斯港海运 42 天交付，赶播种季，2 名工程师驻场调试。客户反馈：作业效率提升42%，轮作切换效率升 50%。',
    testimonial: '拖拉机抗腐不打滑，轮作切换快！没耽误播种，很省心！',
    author: '合作社技术总监 马科斯（Marcos）'
  },
  {
    id: 4,
    customerName: '德国某机械贸易商',
    location: '德国',
    flag: '/images/flags/de.svg',
    products: '代理精密测试设备',
    highlights: '2025年1月，与德国客户达成代理合作，提供精密部件测试仪器，协助完成CE认证与海关清关，建立每月50台的稳定供货机制，客户满意度达98%。',
    testimonial: '产品精度高，跨境服务专业',
    author: '贸易商代表'
  }
];

const features = computed(() => [
  {
    id: 1,
    title: t('home.features.shipping.title'),
    description: t('home.features.shipping.description'),
    icon: 'mdi-truck'
  },
  {
    id: 2,
    title: t('home.features.payment.title'),
    description: t('home.features.payment.description'),
    icon: 'mdi-lock'
  },
  {
    id: 3,
    title: t('home.features.support.title'),
    description: t('home.features.support.description'),
    icon: 'mdi-headphones'
  },
  {
    id: 4,
    title: t('home.features.returns.title'),
    description: t('home.features.returns.description'),
    icon: 'mdi-undo'
  }
])

// 响应式滚动效果 (client-only)
const isClient = typeof window !== 'undefined'
let y = ref(0)
let width = ref(1024)
if (isClient) {
  const scroll = useScroll(window)
  y = scroll.y
  const ws = useWindowSize()
  width = ws.width
}
const {t, locale} = useI18n()

// 检测是否为移动端
const isMobile = computed(() => width.value < 600)

// 视频播放控制
const videoRef = ref<HTMLVideoElement | null>(null);
const isVideoPlaying = ref(false);

// 生命周期钩子
onMounted(() => {
  if (videoRef.value) {
    videoRef.value.play().catch(() => {
      console.log('Video autoplay failed');
    });
  }
});

onUnmounted(() => {
  if (videoRef.value) {
    videoRef.value.pause();
  }
});

// 购物车功能
const addToCart = (product: any) => {
  // 实际应用中，这里会调用购物车服务
  console.log('Added to cart:', product)
  // 可以添加提示信息
}

// 获取技术特点图标
const getTechIcon = (key: string) => {
  const icons = {
    team: 'mdi-account-multiple',  // 博士后团队图标
    components: 'mdi-engine',      // 核心零部件图标
    solutions: 'mdi-cog-transfer', // 定制化方案图标
    standards: 'mdi-shield-check'  // 国际标准图标
  }
  return icons[key as keyof typeof icons] || 'mdi-star'
}

// 处理图片加载错误
const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement;
  target.src = '/images/products/default/placeholder.jpg';
};

// 技术特点数据 - 确保只显示4个指定的技术特点
const techFeatures = computed(() => {
  const allFeatures = t('home.techFeatures')
  const featureKeys = ['team', 'components', 'solutions', 'standards']

  return featureKeys.map(key => ({
    key,
    ...allFeatures[key]
  }))
})

// 播放视频
const playVideo = (event: Event) => {
  const target = event.target as HTMLElement
  const video = target.closest('.video-container')?.querySelector('video') as HTMLVideoElement
  if (video) {
    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  }
}

// 获取本地化文本
const getLocalizedText = (text: any) => {
  if (!text) return '';
  if (typeof text === 'string') return text;
  return text[locale.value] || text.en || '';
};

// 获取推荐产品 - 展示前4个分类的第一个产品
const featuredProducts = computed(() => {
  const recommendedProducts: Array<{
    id: string;
    name: any;
    description: any;
    image: string | undefined;
    category: string;
  }> = [];

  // 获取前4个分类
  const firstFourCategories = productCategories.slice(0, 4);

  // 从每个分类中选择第一个产品
  for (const category of firstFourCategories) {
    if (category.products && category.products.length > 0) {
      const firstProduct = category.products[0];
      recommendedProducts.push({
        id: firstProduct.id,
        name: firstProduct.name,
        description: firstProduct.description,
        image: firstProduct.imageUrl,
        category: category.id
      });
    }
  }

  return recommendedProducts;
});

// 表单相关
const formValid = ref(false)
const submitting = ref(false)
const showQRCode = ref(false)

const contactForm = ref({
  name: '',
  country: '',
  products: [] as string[],
  message: ''
})

// 国家列表（示例）
const countries = [
  'China',
  'United States',
  'United Kingdom',
  'Germany',
  'France',
  'Japan',
  'South Korea',
  // ... 添加更多国家
]

// 产品列表（示例）
const products = [
  'Tractor Model A',
  'Tractor Model B',
  'Harvester X',
  'Planter Y',
  // ... 添加更多产品
]

// 提交表单
const submitContactForm = async () => {
  if (!formValid.value) return

  submitting.value = true
  try {
    // 这里添加实际的表单提交逻辑
    console.log('Form submitted:', contactForm.value)
    // 成功提示
    // 重置表单
    contactForm.value = {
      name: '',
      country: '',
      products: [],
      message: ''
    }
  } catch (error) {
    console.error('Form submission error:', error)
    // 错误提示
  } finally {
    submitting.value = false
  }
}

// 获取当前语言的案例
const currentLocaleCases = computed(() => {
  return locale.value === 'zh' ? mockCasesZh : mockCases;
});

// v-slide-group 轮播引用 + 手动滚动控制
const slideGroupRef = ref<InstanceType<any> | null>(null)
// 受控活动项，避免第一次点击因未选中项导致的无动作
const casesActiveId = ref<string | number | null>(null)
// 移动端轮播索引
const mobileCarouselIndex = ref(0)
// 移动端轮播最小高度
const mobileCarouselMinHeight = ref<string>('auto')

watch(currentLocaleCases, (list) => {
  // 初始化选中第一个项，避免第一次点击需要两次
  if (list && list.length && casesActiveId.value == null) {
    casesActiveId.value = list[0].id
  }
}, { immediate: true })

// 计算移动端轮播最小高度
const calculateMobileCarouselHeight = () => {
  if (typeof window === 'undefined' || width.value >= 768) return
  
  nextTick(() => {
    const firstCard = document.querySelector('.case-card--mobile')
    if (firstCard) {
      const height = firstCard.clientHeight
      if (height > 0) {
        mobileCarouselMinHeight.value = `${height}px`
      }
    }
  })
}

const scrollByDelta = (dir: -1 | 1) => {
  const root = (slideGroupRef as any)?.value?.$el || null
  const wrapper: HTMLElement | null = root?.querySelector('.v-slide-group__container, .v-slide-group') || root
  const content: HTMLElement | null = root?.querySelector('.v-slide-group__content') || wrapper
  if (!content) return
  const delta = Math.round(content.clientWidth * 0.6) * dir
  content.scrollBy({ left: delta, behavior: 'smooth' })
}

const scrollPrev = () => scrollByDelta(-1)
const scrollNext = () => scrollByDelta(1)

// 头像生成函数
const getAvatarColor = (id: number) => {
  const colors = ['#1976d2', '#388e3c', '#f57c00', '#7b1fa2', '#d32f2f', '#0288d1']
  return colors[(id - 1) % colors.length]
}

const getAvatarText = (name: string) => {
  if (!name) return '?'
  // 提取中文或英文的首字符
  const firstChar = name.charAt(0)
  return firstChar.toUpperCase()
}

// 滚动监听
const isScrolled = computed(() => y.value > 50);

// 监听滚动，实现导航栏效果 (client-only)
const handleScroll = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return
  const nav = document.querySelector('.sticky-nav')
  if (nav) {
    if (window.scrollY > 50) {
      nav.classList.add('nav-scrolled')
    } else {
      nav.classList.remove('nav-scrolled')
    }
  }
}

onMounted(() => {
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll)
    // 计算移动端轮播高度
    calculateMobileCarouselHeight()
    // 监听窗口大小变化
    window.addEventListener('resize', calculateMobileCarouselHeight)
  }

  // 设置 Intersection Observer 来检测统计数据元素是否进入视口
  if (statsSection.value) {
    observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isVisible.value) {
              startStatsAnimation()
            }
          })
        },
        {threshold: 0.3}
    )
    observer.observe(statsSection.value)
  }
})

onUnmounted(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('scroll', handleScroll)
    window.removeEventListener('resize', calculateMobileCarouselHeight)
  }

  if (observer) {
    observer.disconnect()
  }
})
</script>

<style scoped>
/* 基础样式 */
.home-page {
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}



/* Banner容器样式 */
.banner-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Banner图片样式 */
.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center center;
  transform: scale(1.05);
  transition: transform 8s ease;
}

.v-carousel__item--active .banner-image {
  transform: scale(1);
}

/* 移动端图片适配 */
@media (max-width: 767px) {
  .banner-image {
    object-fit: cover;
    object-position: center 30%; /* 聚焦图片中上部分 */
  }
}

@media (max-width: 600px) {
  .banner-image {
    object-fit: cover;
    object-position: center 35%; /* 移动端聚焦图片中上部分，显示更多主体内容 */
    transform: scale(1.1); /* 稍微放大以填充空间 */
  }

  .v-carousel__item--active .banner-image {
    transform: scale(1.05);
  }
}

/* 视频包装器样式 */
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Banner视频样式 */
.banner-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Banner遮罩层 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.36) 50%, rgba(0, 0, 0, 0.47) 100%);
  z-index: 1;
}

/* Banner内容容器 */
.banner-content-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-carousel {
  width: 100vw;
  height: calc(39.58vw); /* 基于1920*1080屏幕760px的比例计算 */
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  min-height: 400px; /* 最小高度保护 */
}

.banner-carousel .v-carousel__item {
  height: 100%;
}
/* Banner内容样式 */
.banner-content {
  width: 100%;
  max-width: 1200px;
  position: relative;
  z-index: 5;
}

/* Banner按钮样式 */
.banner-btn {
  font-size: 1.1rem !important;
  padding: 0.75rem 2.5rem !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 500;
  border-radius: 4px;
  box-shadow: 0 4px 15px rgba(var(--v-theme-primary), 0.5) !important;
  transition: all 0.3s ease !important;
}

.banner-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(var(--v-theme-primary), 0.6) !important;
}

/* 文本阴影 */
.text-shadow {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 分类样式 */
.category-card {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  height: 200px;
  border-radius: 8px;
}

.category-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.category-card:hover .category-overlay {
  background: rgba(0, 0, 0, 0.7);
}

/* 商品卡片样式 */
.product-card {
  transition: transform 0.28s cubic-bezier(.2, .9, .2, 1), box-shadow 0.28s cubic-bezier(.2, .9, .2, 1);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(16, 24, 40, 0.04);
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfb 100%);
  box-shadow: 0 6px 18px rgba(14, 20, 28, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(14, 20, 28, 0.12), 0 6px 18px rgba(14, 20, 28, 0.06);
}

.product-image-container {
  position: relative;
  overflow: hidden;
}

.product-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #ff5252;
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.add-to-cart-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  opacity: 0;
  transition: opacity 0.3s;
}

.product-image-container:hover .add-to-cart-btn {
  opacity: 1;
}

.product-details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.product-rating {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.rating-count {
  font-size: 12px;
  color: #757575;
  margin-left: 4px;
}

.product-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}

.product-price {
  margin-top: auto;
}

.current-price {
  font-weight: bold;
  color: rgb(var(--v-theme-primary));
}

.original-price {
  text-decoration: line-through;
  color: #757575;
  margin-left: 8px;
  font-size: 14px;
}

/* 促销卡片样式 */
.promo-card {
  overflow: hidden;
  border-radius: 12px;
}

.promo-btn {
  border-radius: 50px;
  text-transform: uppercase;
  font-weight: bold;
}

/* 客户案例轮播容器 */
.cases-carousel-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 80px;
}

/* v-slide-group样式 */
.cases-slide-group {
  padding: 0 !important;
}

.case-slide-item {
  width: 720px; /* ensure overflow to enable horizontal scroll */
  flex-shrink: 0;
  margin-right: 20px;
}

/* 允许使用自定义插槽箭头（不再隐藏） */

/* 案例卡片样式 */
.case-card {
  height: 100%;
  transition: all 0.3s ease;
  border: none;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  overflow: hidden;
  border-radius: 20px;
}

 

/* 轮播版本的案例卡片 */
.case-card--carousel {
  width:700px;
  min-height: 280px;
  box-sizing: border-box;
}

/* 案例布局 */
.case-layout {
  padding: 24px;
}

/* 内容区域 */
.case-content-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 头部信息（客户名称+国旗） */
.case-header-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.country-flag {
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.case-customer-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  line-height: 1.3;
  flex: 1;
}

.case-product-info {
  font-size: 0.9rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}

.case-highlights {
  font-size: 0.85rem;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.7);
}

.case-testimonial {
  background: rgba(25, 118, 210, 0.04);
  border-radius: 8px;
  padding: 16px;
  border-left: 3px solid #1976d2;
}

.testimonial-text {
  font-size: 0.85rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
  font-style: italic;
}

/* 特色功能样式 */
.feature-card {
  padding: 24px;
  transition: transform 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  color: rgb(var(--v-theme-primary));
}

.feature-title {
  font-weight: 500;
}

/* 技术模块整体样式 */
.tech-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
}

.tech-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(0,0,0,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.5;
  z-index: 1;
}

.tech-section .v-container {
  position: relative;
  z-index: 2;
}

/* 技术卡片样式 */
.tech-card {
  transition: all 0.3s ease;
  padding: 2rem;
  border-radius: 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--v-primary-base), var(--v-secondary-base));
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.tech-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.tech-card:hover::before {
  transform: scaleX(1);
}

/* 技术图标样式 */
.tech-icon-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: rgba(27, 77, 62, 0.05);
  border-radius: 50%;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
}

.tech-icon {
  font-size: 42px !important;
  transition: all 0.3s ease;
  color: rgb(var(--v-theme-primary)) !important;
}

.tech-card {
  border: 1px solid rgba(27, 77, 62, 0.1);
  transition: all 0.3s ease;
  background: white;
  overflow: hidden;
}

.tech-card:hover {
  border-color: rgb(var(--v-theme-primary));
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(var(--v-theme-primary), 0.1);
}

.tech-card:hover .tech-icon-wrapper {
  background: rgb(var(--v-theme-primary));
}

.tech-card:hover .tech-icon {
  color: white !important;
  transform: scale(1.1) rotate(360deg);
}

/* 视频卡片样式 */
.video-card {
  position: relative;
  overflow: hidden;
}

.video-container {
  position: relative;
  height: 250px;
  overflow: hidden;
}

.video-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s;
}

.video-preview:hover {
  transform: scale(1.05);
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s;
  pointer-events: none;
}

.video-card:hover .video-overlay {
  opacity: 1;
}

.video-overlay .v-btn {
  pointer-events: auto;
}

/* 产品卡片样式 */
.product-card {
  transition: transform 0.28s cubic-bezier(.2, .9, .2, 1), box-shadow 0.28s cubic-bezier(.2, .9, .2, 1);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(16, 24, 40, 0.04);
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfb 100%);
  box-shadow: 0 6px 18px rgba(14, 20, 28, 0.06), inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(14, 20, 28, 0.12), 0 6px 18px rgba(14, 20, 28, 0.06);
}

.product-badge {
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: var(--v-primary-base);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.875rem;
  z-index: 1;
}

.product-badge.best-seller {
  background: var(--v-error-base);
  left: auto;
  right: 1rem;
}

/* 联系我们样式 */
.contact-section {
  position: relative;
}

.contact-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
}

.contact-info-card,
.contact-form-card {
  height: 100%;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
}

.contact-method {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.contact-method:hover {
  background: rgba(0, 0, 0, 0.03);
}

/* 订阅区域样式 */
.subscribe-input {
  max-width: 400px;
  margin: 0 auto;
  border-radius: 50px !important;
  background-color: white;
}

/* 页脚样式 */
.footer-text {
  color: rgba(255, 255, 255, 0.7);
}

.social-btn {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
  margin-right: 8px;
}

.social-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.footer-title {
  color: white;
  font-weight: 500;
  margin-bottom: 16px;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  display: block;
  margin-bottom: 8px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: white;
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.contact-item {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.payment-methods {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.payment-icon {
  filter: brightness(0) invert(1);
}

/* 响应式样式 */
@media (max-width: 960px) {
  .banner-content h1 {
    font-size: 2rem !important;
  }

  .banner-content p {
    font-size: 1.2rem !important;
  }

  .text-md-left {
    text-align: left !important;
  }

  .contact-info-card {
    margin-bottom: 2rem;
  }

  /* 标题文字适配 */
  .text-h3 {
    font-size: 1.75rem !important;
  }

  .text-h5 {
    font-size: 1.25rem !important;
  }

  .text-h6 {
    font-size: 1.1rem !important;
  }

  /* 统计数据卡片平板优化 */
  .stat-number {
    font-size: 2.5rem;
  }

  .stat-label {
    font-size: 0.95rem;
  }

  /* 产品卡片平板优化 */
  .product-card .text-h6 {
    font-size: 1.05rem !important;
  }
}

/* Banner styles moved to BannerContent.vue component */

/* 响应式优化 - 基于1920*1080屏幕760px的比例自动缩放 */

/* 超大屏幕优化 */
@media (min-width: 2560px) {
  .banner-carousel {
    height: calc(39.58vw);
    max-height: 1200px; /* 防止过高 */
  }
}

/* 大屏幕优化 */
@media (min-width: 1200px) and (max-width: 2559px) {
  .banner-carousel {
    height: calc(39.58vw);
  }
}

/* 中等屏幕优化 */
@media (min-width: 768px) and (max-width: 1199px) {
  .banner-carousel {
    height: calc(39.58vw);
    min-height: 350px;
  }

  /* 客户案例中等屏幕适配 */
  .case-slide-item {
    width: 500px;
  }

  .case-card--carousel {
    width: 480px;
  }

  /* 技术卡片中等屏幕适配 */
  .tech-card {
    padding: 1.8rem 1.2rem;
  }

  .tech-icon-wrapper {
    width: 90px;
    height: 90px;
  }
}


/* 移动端优化 */
@media (max-width: 767px) {
  .banner-carousel {
    height: 50vh !important;
    min-height: 350px !important;
    max-height: 500px !important;
  }

  .banner-carousel .v-carousel__item {
    height: 100% !important;
  }

  .banner-container {
    overflow: hidden;
    height: 100% !important;
  }

  .banner-image {
    height: 100% !important;
  }

  .video-wrapper {
    height: 100% !important;
  }

  .banner-video {
    height: 100% !important;
    object-fit: cover;
  }

  /* 隐藏移动端轮播箭头 */
  .banner-carousel :deep(.v-carousel__controls) {
    display: none !important;
  }
  
  .banner-carousel :deep(.v-window__controls) {
    display: none !important;
  }
}

@media (max-width: 600px) {
  .nav-actions .v-btn {
    margin: 0 4px;
  }

  .main-nav {
    display: none;
  }

  .banner-carousel {
    height: 50vh !important;
    min-height: 350px !important;
    max-height: 500px !important;
    margin-top: 0;
  }

  .banner-carousel .v-carousel__item {
    height: 100% !important;
  }

  .banner-container {
    height: 100% !important;
    min-height: 100%;
    position: relative;
    overflow: hidden;
  }

  .banner-image {
    height: 100% !important;
    min-height: 100%;
    width: 100%;
    display: block;
  }

  .video-wrapper {
    height: 100% !important;
    min-height: 100%;
    overflow: hidden;
  }

  .banner-video {
    height: 100% !important;
    min-height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center center;
  }

  .banner-content {
    padding: 20px 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    z-index: 3;
  }

  .banner-content-container {
    padding: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .banner-content .v-row {
    margin: 0;
    width: 100%;
  }

  /* 隐藏移动端轮播箭头 */
  .banner-carousel :deep(.v-carousel__controls) {
    display: none !important;
  }

  .banner-carousel :deep(.v-window__controls) {
    display: none !important;
  }

  /* Banner 遮罩层移动端加深 */
  .banner-overlay {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.45) 50%, rgba(0, 0, 0, 0.6) 100%) !important;
  }

  /* 公司介绍模块 */
  .company-intro .text-h3 {
    font-size: 1.35rem !important;
    margin-bottom: 1.2rem !important;
    font-weight: 600 !important;
  }

  .company-overview-content div {
    font-size: 0.95rem !important;
    line-height: 1.6;
    margin-bottom: 0.5rem;
  }

  /* 技术与研发模块 */
  .tech-section .text-h3 {
    font-size: 1.5rem !important;
    margin-bottom: 1rem !important;
  }

  .tech-section .v-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .tech-card {
    padding: 1.5rem 1rem;
    width: 100%;
  }

  .tech-icon-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 1rem;
  }

  .tech-icon {
    font-size: 36px !important;
  }

  .tech-card .text-h5 {
    font-size: 1.1rem !important;
    margin-bottom: 0.75rem !important;
  }

  .tech-card .text-body-1 {
    font-size: 0.9rem !important;
    line-height: 1.5;
  }

  /* 视频展示模块 */
  .video-section .text-h3 {
    font-size: 1.5rem !important;
    margin-bottom: 1rem !important;
  }

  .video-container {
    height: 200px;
  }

  .video-card .text-h6 {
    font-size: 1rem !important;
  }

  /* 推荐产品模块 */
  .featured-products .text-h3 {
    font-size: 1.5rem !important;
    margin-bottom: 1rem !important;
  }

  .product-card .text-h6 {
    font-size: 1rem !important;
  }

  .product-card .text-body-1 {
    font-size: 0.9rem !important;
  }

  /* 统计数据移动端优化 - 一行一个展示 */
  .stat-number {
    font-size: 2rem !important;
  }

  .stat-label {
    font-size: 0.85rem !important;
    line-height: 1.4;
  }

  .stat-card {
    padding: 1.5rem 1rem !important;
    margin-bottom: 0;
  }

  .stat-icon-wrapper {
    width: 75px !important;
    height: 75px !important;
  }

  .stat-col {
    margin-bottom: 1rem;
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .stat-col:last-child {
    margin-bottom: 0;
  }

  /* 按钮移动端优化 */
  .v-btn {
    font-size: 0.875rem !important;
  }

  .v-btn.text-none {
    padding: 0 16px !important;
  }

  /* 推荐产品按钮优化 */
  .featured-products .v-btn {
    font-size: 0.85rem !important;
    height: 36px !important;
  }

  /* 内容容器移动端间距 */
  .content-container {
    padding: 0 16px;
  }

  /* 轮播控制按钮移动端样式 */
  .banner-carousel .v-carousel__controls {
    bottom: 10px;
  }

  /* 减少各区块的垂直间距 */
  .py-16 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-12 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-8 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  /* Mobile banner styles moved to BannerContent.vue component */
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banner-btn {
  font-size: 1rem !important;
  padding: 0.5rem 1.5rem !important;
  position: relative;
  z-index: 10;
}

.category-card {
  height: 150px;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 公司介绍样式 */
.company-intro {
  background: #fff;
}

.company-card {
  border-radius: 16px;
  box-shadow: none;
  transition: all 0.3s ease;
}

.company-card:hover {
  transform: translateY(-4px);
}

/* 公司图片样式 */
.company-image-wrapper {
  position: relative;
  border-radius: 0px;
  overflow: hidden;
  box-shadow: none;
  transition: all 0.3s ease;
  width: 100%;
  align-self: flex-start;
}

.company-image-wrapper:hover {
  transform: translateY(-8px);
}

.company-image {
  border-radius: 0px;
  transition: all 0.3s ease;
  width: 100%;
  margin-bottom: 20px;
}


.company-image-wrapper:hover .company-image {
  transform: scale(1.05);
}

/* 公司介绍按钮样式：短文案与图片对齐，超出截断 */

.company-viewmore-btn .btn-text {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* 新的公司统计数据样式 */
.company-stats-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 4rem 0;
  margin-top: 2rem;
  position: relative;
  overflow: hidden;
}

.company-stats-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 20%, rgba(var(--v-theme-primary), 0.05) 0%, transparent 50%),
  radial-gradient(circle at 80% 80%, rgba(var(--v-theme-secondary), 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.stat-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 2.5rem 1.5rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(27, 77, 62, 0.1);
  background-clip: padding-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  box-shadow: none;

  /* 初始状态 - 用于动画 */
  opacity: 0;
  transform: translateY(60px) scale(0.9);
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(145deg, rgba(var(--v-theme-primary), 0.02) 0%, rgba(var(--v-theme-secondary), 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 20px;
}

/* 顶部渐变条：与技术与研发模块一致的边框动画 */
.stat-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--v-primary-base), var(--v-secondary-base));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.stat-card:hover::before {
  opacity: 1;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(var(--v-theme-primary), 0.1);
  border-color: rgb(var(--v-theme-primary));
}

.stat-card:hover::after {
  transform: scaleX(1);
}

/* 入场动画 */
.stat-card.animate-in {
  animation: slideInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  animation-delay: var(--delay);
}

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.stat-icon-wrapper {
  margin-bottom: 1.5rem;
  position: relative;
}

.stat-icon {
  color: rgb(var(--v-theme-primary));
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.1) 0%, rgba(var(--v-theme-secondary), 0.1) 100%);
  padding: 1rem;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(var(--v-theme-primary), 0.2);
}

.stat-card:hover .stat-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 6px 20px rgba(var(--v-theme-primary), 0.3);
}

.stat-number {
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(135deg, rgb(var(--v-theme-primary)) 0%, rgb(var(--v-theme-secondary)) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.8rem;
  line-height: 1;
  transition: all 0.3s ease;
}

.stat-card:hover .stat-number {
  transform: scale(1.05);
}

.stat-label {
  font-size: 1rem;
  color: #64748b;
  font-weight: 600;
  text-align: center;
  line-height: 1.4;
  letter-spacing: 0.3px;
  transition: color 0.3s ease;
}


.stat-card:hover .stat-label {
  color: #475569;
}

/* 脉冲动画效果 */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.stat-number {
  animation: pulse 2s ease-in-out infinite;
  animation-delay: calc(var(--delay) + 1s);
}

@media (max-width: 768px) {
  .stat-number {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 0.85rem;
    line-height: 1.3;
  }

  .stat-card {
    padding: 1.8rem 1rem;
  }

  .company-stats-section {
    padding: 2.5rem 0;
  }

  .stat-icon {
    padding: 0.75rem;
  }

  .stat-icon-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 1rem;
  }

  /* 移动端一行一个统计卡片的间距调整 */
  .stat-col {
    margin-bottom: 0.5rem;
  }

  .stat-col:last-child {
    margin-bottom: 0;
  }
}

/* 旧的统计数据样式 */
.company-stats {
  border-top: 2px solid rgba(27, 77, 62, 0.1);
  padding-top: 24px;
}

.stat-item {
  padding: 16px 8px;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-4px);
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: rgb(var(--v-theme-primary));
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.line-height-2 {
  line-height: 2;
}

.product-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.product-image {
  border-radius: 8px 8px 0 0;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-medium-emphasis {
  opacity: 0.85;
}

/* 客户案例样式 */
.customer-cases {
  background: linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%);
  position: relative;
}

.customer-cases::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(0,0,0,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.5;
  z-index: 0;
}

.customer-cases .content-container {
  position: relative;
  z-index: 1;
}

/* 导航按钮 */
.cases-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.2);
  transition: all 0.3s ease;
}

.cases-nav-btn:hover {
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 12px 35px rgba(25, 118, 210, 0.3);
}

.cases-nav-btn--left {
  left: 20px;
}

.cases-nav-btn--right {
  right: 20px;
}

.cases-nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.cases-nav-btn:disabled:hover {
  transform: translateY(-50%);
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.2);
}


.text-medium-emphasis {
  color: rgba(0, 0, 0, 0.6);
}

/* 移动端轮播容器 */
.cases-mobile-carousel {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
  transition: min-height 0.3s ease;
}

.cases-carousel {
  border-radius: 0;
  min-height: inherit;
}

/* 轮播项包装器 */
.carousel-item-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px 40px 8px;
  box-sizing: border-box;
}

/* 隐藏移动端轮播箭头 */
.cases-carousel :deep(.v-window__controls) {
  display: none !important;
}

.case-card--mobile {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  width: 100%;
  max-width: 100%;
  min-height: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* 自定义轮播指示器样式 */
.cases-carousel :deep(.v-carousel__controls) {
  background: transparent !important;
  padding: 16px 0 !important;
  position: relative !important;
  bottom: 0 !important;
  height: auto !important;
}

.cases-carousel :deep(.v-carousel__controls__item) {
  margin: 0 4px !important;
}

.cases-carousel :deep(.v-carousel__controls .v-btn) {
  width: 10px !important;
  height: 10px !important;
  min-width: 10px !important;
  min-height: 10px !important;
  opacity: 0.3 !important;
  transition: all 0.3s ease !important;
}

.cases-carousel :deep(.v-carousel__controls .v-btn .v-icon) {
  font-size: 10px !important;
  color: rgb(var(--v-theme-primary)) !important;
}

.cases-carousel :deep(.v-carousel__controls .v-btn--active) {
  opacity: 1 !important;
  width: 12px !important;
  height: 12px !important;
}

.cases-carousel :deep(.v-carousel__controls .v-btn--active .v-icon) {
  font-size: 12px !important;
  color: rgb(var(--v-theme-primary)) !important;
}

/* 移动端响应式 */
@media (max-width: 960px) {
  .cases-carousel-container {
    padding: 0 60px;
  }
  
  .case-slide-item {
    width: 450px;
  }

  .case-card--carousel {
    width: 430px;
  }
  
  .cases-nav-btn {
    width: 48px;
    height: 48px;
  }
  
  .cases-nav-btn--left {
    left: 10px;
  }
  
  .cases-nav-btn--right {
    right: 10px;
  }
  
  .case-card--carousel {
    min-height: 280px;
  }
  
  .case-layout {
    padding: 20px;
  }
  
  .case-content-section {
    gap: 14px;
  }
  
  .country-flag {
    width: 20px;
    height: 15px;
  }
  
  
  .case-customer-name {
    font-size: 1.05rem;
    line-height: 1.4;
  }
  
  .case-product-info {
    font-size: 0.88rem;
    line-height: 1.5;
  }
  
  .case-highlights {
    font-size: 0.82rem;
    line-height: 1.6;
  }
  
  .testimonial-text {
    font-size: 0.82rem;
    line-height: 1.5;
  }

  .case-testimonial {
    padding: 14px;
  }
}

@media (max-width: 767px) {
  /* 移动端轮播样式 */
  .carousel-item-wrapper {
    padding: 0 6px 40px 6px;
  }

  .case-card--mobile {
    width: 100%;
  }
  
  .case-card--mobile .case-layout {
    padding: 18px 16px 20px 16px;
  }
  
  .case-card--mobile .case-content-section {
    gap: 12px;
  }
  
  .case-card--mobile .case-header-info {
    margin-bottom: 6px;
  }
  
  .case-card--mobile .case-customer-name {
    font-size: 1rem;
    line-height: 1.4;
    font-weight: 600;
  }
  
  .case-card--mobile .case-product-info {
    font-size: 0.85rem;
    line-height: 1.5;
  }
  
  .case-card--mobile .case-highlights {
    font-size: 0.8rem;
    line-height: 1.6;
  }
  
  .case-card--mobile .testimonial-text {
    font-size: 0.8rem;
    line-height: 1.55;
  }
  
  .case-card--mobile .case-testimonial {
    padding: 12px 14px;
    margin-top: 6px;
  }

  /* 标题文字适配 */
  .customer-cases .text-h3 {
    font-size: 1.4rem !important;
    margin-bottom: 0.75rem !important;
  }

  .customer-cases .text-h6 {
    font-size: 0.9rem !important;
  }

  /* 技术与研发区块间距优化 */
  .tech-section {
    padding: 2.5rem 0 !important;
  }

  .tech-section .mb-12 {
    margin-bottom: 1.5rem !important;
  }

  /* 视频展示区块间距优化 */
  .video-section {
    padding: 2.5rem 0 !important;
  }

  .video-section .mb-12 {
    margin-bottom: 1.5rem !important;
  }

  /* 推荐产品区块间距优化 */
  .featured-products {
    padding: 2.5rem 0 !important;
  }

  .featured-products .mb-12 {
    margin-bottom: 1.5rem !important;
  }

  /* 客户案例区块间距优化 */
  .customer-cases {
    padding: 2rem 0 !important;
  }

  .customer-cases .mb-8 {
    margin-bottom: 1rem !important;
  }
  
}

.company-overview-text {
  line-height: 1.6;
}

.company-overview-content div {
  margin-bottom: 2px;
  line-height: 1.6;
  font-size: 1.08rem;
  color: #222;
  font-family: 'Microsoft YaHei', 'Arial', sans-serif;
}
</style>
